// Mantine
import { Anchor, Progress, RingProgress, Button } from '@mantine/core'

// Dayjs
import dayjs from 'dayjs'
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import 'dayjs/locale/fr'
dayjs.extend(LocalizedFormat)
dayjs.locale('fr')

// Next
import { Link } from 'react-router-dom'

// Box
import Box from '../ui/Box'

import ProductionOrderSmallDisplay from '../production_orders/ProductionOrderSmallDisplay'

export default function ComponentParentsProductionOrders({
    component,
    parentsProductionOrders,
}) {
    return (
        <Box
            className="p-5 bg-white border rounded-sm flex flex-col"
            title="Utilisé pour les assemblages"
            subtitle="Quantités affectées à des assemblages"
            maxHeight="400px"
        >
            {parentsProductionOrders.length === 0 && (
                <div className="text-gray-400">Aucun assemblage en cours</div>
            )}

            <div className="flex flex-col gap-2">
                {[...parentsProductionOrders]
                    .sort((a, b) => new Date(a.starting_at) - new Date(b.starting_at))
                    .map((production_order) => {
                    // Calculate the percentage of the quantity in control
                    const quantityInControlPercentage =
                        (production_order.quantity_in_control /
                            production_order.quantity) *
                        100

                    // Calculate the percentage of the quantity completed
                    const quantityCompletedPercentage =
                        (production_order.quantity_completed /
                            production_order.quantity) *
                        100

                    // Get verbose ending_at date
                    const endingAt = dayjs(production_order.ending_at).format(
                        'dddd D MMMM YYYY'
                    )

                    return (
                        <ProductionOrderSmallDisplay
                            production_order={production_order}
                            key={production_order.id}
                            isOutput={true}
                        />
                    )

                    return (
                        <Link
                            className="flex justify-between items-center border p-2 rounded-xl hover:bg-gray-50"
                            key={production_order.id}
                            to={`/assembly/${production_order.id}`}
                        >
                            <Anchor>
                                A{production_order.id} -{' '}
                                {production_order.component.name} (
                                {production_order.quantity})
                            </Anchor>

                            <span className="text-sm text-gray-400">
                                Sera terminé le {endingAt}
                            </span>

                            <div className="block">
                                <RingProgress
                                    size={40}
                                    thickness={12}
                                    sections={[
                                        {
                                            value: quantityInControlPercentage,
                                            color: 'orange',
                                            tooltip:
                                                'En contrôle qualité : ' +
                                                production_order.quantity_in_control +
                                                ' / ' +
                                                production_order.quantity,
                                        },
                                        {
                                            value: quantityCompletedPercentage,
                                            color: 'green',
                                            tooltip:
                                                'Terminé : ' +
                                                production_order.quantity_completed +
                                                ' / ' +
                                                production_order.quantity,
                                        },
                                    ]}
                                />
                            </div>
                        </Link>
                    )
                })}
            </div>
        </Box>
    )
}
